<template>
<div class="chapter">
<div class="inner_page">
<a id="pvii"></a>
<blockquote class="sink">
<p class="center ">When what we hoped for came to nothing, we revived.</p>
<p class="right "><span class="smallcaps">—MARIANNE MOORE</span></p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front03.vue?4dbfadfd